import { Box } from '@mui/material';
import React from 'react';
import AssetImage from '../AssetImage';

export default function HighlightImagePicker({
  images,
  selectedUrl,
  onSelect,
  showNoImageOption = false,
}: {
  images: string[];
  selectedUrl: string;
  onSelect: (url: string) => void;
  showNoImageOption?: boolean;
}) {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {images.map((imgUrl) => (
        <Box
          key={imgUrl}
          onClick={() => onSelect(imgUrl)}
          sx={{
            cursor: 'pointer',
            borderRadius: 1,
            border: '2px solid',
            borderColor: selectedUrl === imgUrl ? 'primary.main' : 'transparent',
            overflow: 'hidden',
            width: 80,
            height: 55,
            flexShrink: 0,
          }}
        >
          <AssetImage
            url={imgUrl}
            sx={{ width: 80, height: 55, objectFit: 'cover', display: 'block' }}
          />
        </Box>
      ))}
      {showNoImageOption && (
        <Box
          sx={{
            width: 80,
            height: 55,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderRadius: 1,
            border: '2px solid',
            borderColor: !selectedUrl ? 'primary.main' : 'divider',
            color: !selectedUrl ? 'primary.main' : 'text.secondary',
            fontSize: '0.7rem',
          }}
          onClick={() => onSelect('')}
        >
          No image
        </Box>
      )}
    </Box>
  );
}
